import React from "react";
import { useTranslation } from "react-i18next";
import { Navvbar } from "../../components";

const DHeader = (props) => {
    const { t } = useTranslation();

    const navItems = [
        // {
        //     title: 'How it works',
        //     items: [
        //         { label: 'option 1', path: '/option1' },
        //         { label: 'option 2', path: '/option2' },
        //         { label: 'option 3', path: '/option3' },
        //         { label: 'option 4', path: '/option4' },
        //     ],
        // },
        { title: t("doctor.header.nav.how_its_works"), link: "book-an-appointment" },
        { title: t("doctor.header.nav.payment_plan"), link: "payment-plan" },
        { title: t("doctor.header.nav.team"), link: "team" },
        { title: t("doctor.header.nav.contact"), link: "contact" },
    ];
    return (
        <Navvbar.Navvbar
            brandName="ExaDo"
            imgLink="/doctor"
            navItems={navItems}
            className="dheader"
            userType="doctor"
            onPathClick={() => props.handlePath("/doctor/login")}
            {...props}
        />
    );
};

export default DHeader;
